import { atom } from 'recoil';
import { getRecoil, setRecoil } from 'recoil-nexus';
import { isURIEncoded } from '../helpers';

const pageTitleAtom = atom({
	key: 'pageTitle',
	default: 'Page Title',
});

export function setPageTitle(title: string) {
	let safeTitle = title || 'Page Title';
	
	if (isURIEncoded(safeTitle)) {
		try {
			safeTitle = decodeURIComponent(title);
		} catch (error) {
			console.warn('Page title contains invalid URI encoding, using as-is:', title);
		}
	}
	
	setRecoil(pageTitleAtom, safeTitle);
}

export function usePageTitle() {
	return getRecoil(pageTitleAtom);
}
